<template>    
    <BaseModal
        :id="'static-update'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <div class="row m-0 formdynamic justify-content-md-between" style="padding-top:10px;" v-if="single_object.response_type === 1 && single_object.answers_data.length">
                    <div v-for="(item, i) in single_object.answers_data" :key="i" :class="'col-md-12'" class="p-0 formdynamic__item" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Answer #${i+1} <b style='color:red;'>*</b>`" class="modal-label"/>
                            <input
                                :type="'text'" 
                                :maxlength="'150'"
                                :required="true"
                                v-model="item.answer_text"
                            />
                        </div>
                    </div>
                    <div class="modal__buttons text-center text-md-right">
                        <button 
                            v-if="single_object.answers_data.length < 5"
                            type="button"
                            class="modal__buttons__item" 
                            v-html="`Add answer <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" 
                            style="margin-left:0px;"
                            @click="pushAnswerField()"
                        />
                        <button 
                            v-if="single_object.answers_data.length+1 > 3"
                            type="button"
                            class="modal__buttons__item" 
                            v-html="`Remove last answer`"
                            :style="single_object.answers_data.length >= 5 ? `margin-left:0px;` : ''"
                            @click="spliceLastAnswerField()"
                        />
                    </div>
                </div>
                <div class="row m-0 formdynamic justify-content-md-between" style="padding-top:10px;" v-else-if="single_object.response_type === 1 && !single_object.answers_data.length">
                    <div v-for="(item, i) in answers_data" :key="i" :class="'col-md-12'" class="p-0 formdynamic__item" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Answer #${i+1} <b style='color:red;'>*</b>`" class="modal-label"/>
                            <input
                                :type="'text'" 
                                :maxlength="'150'"
                                :required="true"
                                v-model="item.answer_text"
                            />
                        </div>
                    </div>
                    <div class="modal__buttons text-center text-md-right">
                        <button 
                            v-if="answers_data.length < 5"
                            type="button"
                            class="modal__buttons__item" 
                            v-html="`Add answer <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" 
                            style="margin-left:0px;"
                            @click="pushAnswerField(true)"
                        />
                        <button 
                            v-if="answers_data.length+1 > 3"
                            type="button"
                            class="modal__buttons__item" 
                            v-html="`Remove last answer`"
                            :style="single_object.answers_data.length >= 5 ? `margin-left:0px;` : ''"
                            @click="spliceLastAnswerField(true)"
                        />
                    </div>
                </div>
                <CentralButtons /> 
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'UpdateModal',
    props: [
        'title',
        'rest_api',
        'notifications',
        'notyf',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_format: FormResources.form_format,
            answers_data: FormResources.answers_data,
            answers_data_restore: [...FormResources.answers_data],
        }
    },
    
    methods:{

        pushAnswerField(empty = false)
        {
            if(empty)
            {
                this.answers_data.push(
                    {
                        id: '',
                        answer_text: '',
                    },
                )
                return true
            }

            this.single_object.answers_data.push(
                {
                    id: '',
                    answer_text: '',
                },
            )
        },

        spliceLastAnswerField(empty = false)
        {
            if(empty)
            {
                this.answers_data.splice(this.answers_data.length-1, 1)
                return true
            }
            this.single_object.answers_data.splice(this.single_object.answers_data.length-1, 1)
        },

        async form_submit()
        {
            if(!this.single_object.answers_data.length)
            {
                this.single_object.answers_data = this.answers_data
            }
            // console.log(this.single_object)
            await this.form_submit_update(this.single_object.id, this.global_index)
            this.answers_data = [...this.answers_data_restore]
        },

    },

    mounted()
    {
        this.answers_data.map(item => item.answer_text = '')
    }
    
}
</script>